






























import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import CommunityGroups from '@/web/views/admin/community/CommunityGroups';
import CommunityGroupFormModal from '@/web/views/admin/community/CommunityGroupFormModal';
import { errorToMessage } from '@/core/utils/errors';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import UpgradeYourPlanModal from '@/web/components/settings/UpgradeYourPlanModal.vue';

export default Vue.extend({
  name: 'Community',
  components: {
    TopNav,
    NavItem,
    CommunityGroups,
  },
  data() {
    return {
      inProcess: true,
      upgradePlanDescription: null,
    };
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
    getEmptyGroupsImage() {
      switch (this.teacher.identity) {
        case 'mindset coach':
        case 'wellness coach':
        case 'business coach':
        case 'life coach':
          return 'https://dv05ui3l6dkej.cloudfront.net/Community-coach.png';
        case 'yoga teacher':
        case 'fitness instructor':
        case 'pilates instructor':
        case 'physical studio owner':
          return 'https://dv05ui3l6dkej.cloudfront.net/Community-wellness-teacher.png';
        case 'course creator':
        case 'influencer':
          return 'https://dv05ui3l6dkej.cloudfront.net/Community-course-creator.png';
        case 'designer':
        case 'copywriter':
        case 'developer':
        case 'photographer':
        case 'illustrator':
        case 'service provider':
          return 'https://dv05ui3l6dkej.cloudfront.net/Community-service-provider.png';
        default:
          return 'https://dv05ui3l6dkej.cloudfront.net/Community-wellness-teacher.png';
      }
    },
    groups() {
      return this.$store.state.community.teacherGroups;
    },
    activeGroupsCount() {
      return this.groups.filter(item => item.active)?.length;
    },
    isReachedLimit() {
      return this.teacher.max_community_groups == this.activeGroupsCount;
    },
  },
  methods: {
    async loadGroups() {
      try {
        this.inProcess = true;
        await this.$store.dispatch('community/loadGroups');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }
    },
    openModal() {
      if (this.isReachedLimit) {
        this.showUpgradeYourPlanModal();
      } else {
        this.openAddGroupModal();
      }
    },
    openAddGroupModal() {
      this.$modal.show(
        CommunityGroupFormModal,
        {
          group: {
            display_members: true,
          },
          confirm: this.addGroup,
        },
        {
          clickToClose: false,
          classes: ['vm--inline-modal'],
        }
      );
    },
    async addGroup(group) {
      try {
        this.inProcess = true;
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t(
            'COMMUNITY.NOTIFICATIONS.GROUP_WAS_SUCCESSFULLY_CREATED'
          ),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }

      await this.$store.dispatch('community/addGroup', {
        group_name: group?.group_name,
        cover_photo: group?.cover_photo?.id,
        thumbnail_photo: group?.thumbnail_photo?.id,
        products: formatObjectForBackend(cloneDeep(group?.products)),
        hashtags_enabled: group?.hashtags_enabled,
        hashtags: group?.hashtags,
        display_members: group?.display_members,
      });
      await this.loadGroups();
    },
    showUpgradeYourPlanModal() {
      this.$modal.show(UpgradeYourPlanModal, {
        description: this.upgradePlanDescription,
      });
    },
  },
  mounted() {
    this.loadGroups();
  },
  watch: {
    activeGroupsCount: {
      handler(value) {
        this.upgradePlanDescription = this.$tc(
          'COMMUNITY.TEXT.YOUR_PLAN_SUPPORTS_UP_TO_FIVE_GROUPS',
          this.teacher.max_community_groups,
          this.activeGroupsCount,
          {
            groupsLimit: this.teacher.max_community_groups,
            groupsCount: this.activeGroupsCount,
          }
        );
      },
    },
  },
});
